import { createStore } from "solid-js/store";
import { useApplication } from "@/context/app";
import { save } from "../requests/appointment";
import { list as patientList } from "../requests/patient";
import { createSignal, onMount } from "solid-js";

export default function useAppointment(props) {
  const [loading, setLoading] = createSignal(false);
  const [fetching, setFetching] = createSignal(false);
  const [showAssociate, setShowAssociate] = createSignal(false);
  const [mode, setMode] = createSignal('create');
  const [patients, setPatients] = createSignal([]);
  const [genders, setGenders] = createSignal([
    { value: "Male", text: "Male" },
    { value: "Female", text: "Female" },
    { value: "Other", text: "Other" },
    { value: "N/A", text: "N/A" },
  ]);
  const [bloodGroups, setBloodGroups] = createSignal([
    { value: "A+", text: "A+" },
    { value: "A-", text: "A-" },
    { value: "B+", text: "B+" },
    { value: "B-", text: "B-" },
    { value: "O+", text: "O+" },
    { value: "O-", text: "O-" },
    { value: "AB+", text: "AB+" },
    { value: "AB-", text: "AB-" },
    { value: "N/A", text: "N/A" },
  ]);
  const [types, setTypes] = createSignal([
    { value: "self", text: "Self" },
    { value: "child", text: "Child" },
    { value: "other", text: "Other" },
  ]);
  const [entries, setEntries] = createSignal([
    { value: true, text: "Yes" },
    { value: false, text: "No" },
  ]);
  const [statuses, setStatuses] = createSignal([
    { value: "Pending", text: "Pending" },
    { value: "Queue", text: "Paid" },
  ]);
  const [form, setForm] = createStore({
    date: new Date().toISOString().split('T')[0],
    newPatient: true,
    patientId: null,
    name: "",
    gender: null,
    bloodGroup: null,
    birthDate: new Date().toISOString().split('T')[0],
    type: "self",
    associateName: "",
    cnic: "",
    phone: "",
    email: "",
    fees: 0,
    status: "Pending",
  });

  const { successToast, errorToast } = useApplication();

  const handleSave = async(ev) => {
    ev.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData();
      Object.keys(form).forEach(key => formData.append(key, form[key]));

      if (form.type === 'self') {
        formData.set('associateName', form.name);
      }

      const data = await save(formData);

      if (data.success) {
        successToast(data.message);
        props.onSaved?.();
        return;
      }

    } catch (error) {
      errorToast(error);
    } finally {
      setLoading(false);
    }
  }

  const handleInput = (name, value) => {
    setForm([name], value);

    if (name === 'type' && value === 'self') {
      setShowAssociate(false);
    } else if (name === 'type' && value !== 'self') {
      setShowAssociate(true);
    }
  };

  onMount(async () => {
    setLoading(false);

    try {
      const data = await patientList();
      setPatients(data.list);
    } catch(error) {
      setPatients([]);
    }
  })

  return {
    form,
    mode,
    setMode,
    loading,
    fetching,
    genders,
    bloodGroups,
    types,
    entries,
    patients,
    statuses,
    showAssociate,
    handleInput,
    handleSave,
  };
}
